import { Component, OnInit } from '@angular/core';
import { CalcsService } from '../calcs.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {

  data = []
  displayedColumns: string[] = ['month', 'pmt', 'prinPmt', 'intPmt', 'op', 'balance', 'ltv'];
  
  constructor(
    public calcService: CalcsService) { }

  ngOnInit(): void {
    this.refresh()
  }

  refresh() {
    this.data = this.calcService.getSchedule()
    this.calcService.amended = false
  }

}
